var map = {
	"./1-active.png": "Ldj4",
	"./2-active.png": "O84m",
	"./3-active.png": "rBrb",
	"./4-active.png": "p1G5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "u3mG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/nav ^\.\/.*\-active\.png$
// module id = u3mG
// module chunks = 0